// src/lib/punchAccess.js
// 出退勤（打刻・勤怠）画面を表示しない社員の判定ユーティリティ。
//
// ■ 判定は「役職名（position）」で行う（2026-09-12 にこの方式へ変更）
//    ※ 対象を増減したい場合は HIDDEN_PUNCH_POSITIONS を編集してください。
//
//    ID（社員コード・ログイン ID）で判定していた頃は、次の理由で機能していなかった。
//      - /api/employee/me/ は memberId・employeeId の両方に CustomUser.employee_id
//        （ログイン ID）を返すため、Employee.memberId / employeeId では一致しない
//      - 社長は employeeId='S0001' だがログイン ID は '0000' で、値が環境ごとに異なる
//        （本番 VPS② と検証機 VPS① で違う。桁数も揃っていない）
//    役職名なら ID の桁数・採番規則に依存しないため、環境をまたいでも同じ判定になる。
//    有給の対象外判定（views.py の position__icontains='社長'）や positionRank.js など、
//    既存コードも社長クラスの判定は役職名で行っており、方式もそちらに揃う。

/** この役職名を含む社員は打刻を表示しない（部分一致・前後空白と大小文字は無視） */
export const HIDDEN_PUNCH_POSITIONS = ["社長", "代表取締役"];

/**
 * 役職名では拾えない特殊アカウントを個別に隠したいときだけ使う補助リスト。
 * 書く値は「ログイン ID」（CustomUser.employee_id）。
 * 通常は空のままにしておくこと。ここに値を入れると役職名による判定が実際に
 * 効いているかを画面で確認できなくなり、役職名側の不具合に気づけなくなる。
 */
export const HIDDEN_PUNCH_MEMBER_IDS = [];

function norm(v) {
  return (v ?? "").toString().trim().toUpperCase();
}

const HIDDEN_ID_SET = HIDDEN_PUNCH_MEMBER_IDS.map(norm);
const HIDDEN_POSITIONS = HIDDEN_PUNCH_POSITIONS.map(norm);

/** 役職名が対象か（部分一致）。「代表取締役社長」のような表記も拾う */
export function isPunchHiddenForPosition(position) {
  const p = norm(position);
  if (!p) return false;
  return HIDDEN_POSITIONS.some((k) => k && p.includes(k));
}

/** 指定の社員コード（memberId / employeeId のいずれか）が補助リストに載っているか */
export function isPunchHiddenForId(...ids) {
  return ids.some((id) => id && HIDDEN_ID_SET.includes(norm(id)));
}

/**
 * 社員オブジェクト（/api/employee/me/ や /api/employees/me/ の応答）が打刻非表示対象か。
 * 役職名で判定し、補助リストに載っていれば ID でも拾う。
 */
export function isPunchHiddenForEmployee(emp) {
  if (!emp) return false;
  return (
    isPunchHiddenForPosition(emp.position) ||
    isPunchHiddenForId(emp.memberId, emp.employeeId)
  );
}

/** ログイン中の社員（localStorage "user"）が打刻非表示対象か */
export function isPunchHiddenForCurrentUser() {
  try {
    const u = JSON.parse(localStorage.getItem("user") || "null");
    return isPunchHiddenForEmployee(u);
  } catch {
    return false;
  }
}
